import type { UUID } from '@protector/utils/types';
import axiosRest from 'axios';
import axios from 'axios-observable';
import { PROTECTOR_API_URL } from 'config/constants';
import { map } from 'rxjs/operators';
import type { Config, Report } from '@protector/entities/powerbi-reports/models';
import { EntityType } from '@protector/entities/powerbi-reports/constants';

const protectorApiUrl = PROTECTOR_API_URL;
const powerBIUrl = '/api/v1/powerbi/orgs/';
const powerBIV2Url = `${PROTECTOR_API_URL}/api/v2/powerbi`;

const mountUrlPowerBi = (orgID: UUID) => `${protectorApiUrl + powerBIUrl + orgID}/configs`;

export const getReports = (organizationId: UUID, configID: UUID) => {
  return axios.get<Report>(`${mountUrlPowerBi(organizationId)}/${configID}/report`).pipe(map(response => response.data));
};

export const getConfigsReports = (organizationId: UUID) => {
  return axios.get<Config[]>(`${mountUrlPowerBi(organizationId)}`).pipe(map(response => response.data));
};

export const getReportsV2 = async (entityId: UUID, entityType: EntityType) => {
  const url = `${powerBIV2Url}/report`;
  const params = {
    entity_id: entityId,
    entity_type: entityType
  };
  const response = await axiosRest.get<Report>(url, { params });
  return response.data;
};

export const getConfigsReportsV2 = async (entityId: UUID, entityType: EntityType) => {
  const response = await axiosRest.get<Config[]>(`${powerBIV2Url}/configs`, { params: { entity_id: entityId, entity_type: entityType } });
  return response.data;
};
